import base from './base.repository';

export default {
    login: (username, password) => base.post('rounds/login', { username, password })
}